<script setup>
import { onMounted } from 'vue'
import { useStore } from 'vuex'
import PageDecorations from '@/components/layout/PageDecorations.vue'

const store = useStore()

onMounted(() => {
  if (localStorage.getItem('token')) {
    store.dispatch('auth/fetchUser')
  }
})
</script>

<template>
  <div class="app-root relative min-h-screen overflow-x-hidden">
    <PageDecorations />
    <div class="app-content">
      <router-view />
    </div>
  </div>
</template>
